import React from "react";
import * as esriSymbolUtils from "@arcgis/core/symbols/support/symbolUtils";

const CSS = {
    base: "esri-legend",
    widget: "esri-widget",
    panel: "esri-widget--panel",
    widgetIcon: "esri-icon-layer-list",
    service: "esri-legend__service",
    label: "esri-legend__service-label",
    layer: "esri-legend__layer",
    groupLayer: "esri-legend__group-layer",
    groupLayerChild: "esri-legend__group-layer-child",
    layerTable: "esri-legend__layer-table",
    layerTableSizeRamp: "esri-legend__layer-table--size-ramp",
    layerChildTable: "esri-legend__layer-child-table",
    layerCaption: "esri-legend__layer-caption",
    layerBody: "esri-legend__layer-body",
    layerRow: "esri-legend__layer-row",
    layerInfo: "esri-legend__layer-cell esri-legend__layer-cell--info",
    symbolContainer: "esri-legend__layer-cell esri-legend__layer-cell--symbols",
    symbol: "esri-legend__symbol",
    sizeRamp: "esri-legend__size-ramp",
    colorRamp: "esri-legend__color-ramp",
    opacityRamp: "esri-legend__opacity-ramp",
    // common
    header: "esri-widget__heading",
    hidden: "esri-hidden",
    // geo
    geoInvisible: "geo-invisible",
    geoLayerNotSelected: "geo-legend-layer-not-selected",
    geoLegendDisabled: "geo-legend-disabled"
};

interface LegendPatchProps {
    elementInfo: __esri.SymbolTableElementInfo;
}
export class LegendPatch extends React.Component<LegendPatchProps, any> {
    isMounted = false;
    watchHandles: any[] = [];
    autorunDisposers: any[] = [];
    symbolRef: React.RefObject<any>;
    constructor(props: LegendPatchProps) {
        super(props);
        this.state = {
            preview: null
        };
        this.symbolRef = React.createRef();
    }
    componentDidMount(): void {
        this.isMounted = true;
        const {elementInfo} = this.props;
        const symbolOptions: any = {node: this.symbolRef.current};
        if (elementInfo.symbol.type === "simple-line") {
            symbolOptions["size"] = { width: 25};
        } else if (elementInfo.symbol.type === "simple-fill") {
            symbolOptions["size"] = 14;
        }
        esriSymbolUtils.renderPreviewHTML(elementInfo.symbol, symbolOptions)
            .then((element) => {
                if(this.isMounted) {
                    this.setState({preview: element});
                }
            });
    }
    componentWillUnmount() {
        this.isMounted = false;
    }

    render(): JSX.Element | null {
        const {preview} = this.state;
        return (<div className={CSS.symbol}>
            <div
                ref={this.symbolRef}
                style={preview? {opacity: preview.style.opacity}: undefined}>
            </div>
        </div>);
    }
}
